/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.record-link[_ngcontent-%COMP%]{margin-left:12px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3JlY29yZC1lZGl0b3IvbWFudWFsLW1lcmdlLW1vZGFsL21hbnVhbC1tZXJnZS1tb2RhbC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3RyYXZpcy9idWlsZC9pbnNwaXJlaGVwL3JlY29yZC1lZGl0b3Ivc3JjL2FwcC9yZWNvcmQtZWRpdG9yL21hbnVhbC1tZXJnZS1tb2RhbC9tYW51YWwtbWVyZ2UtbW9kYWwuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/record-editor/manual-merge-modal/manual-merge-modal.component.scss.shim.ngstyle.ts